<div v-if="!!configuration">
	<collapsible-help id="google-review" :title="$t('vm.root.parameters.google-review.title')" tag="h1">
		<svg slot="icon" width="1em" class="svg-middle" viewBox="0 0 512 512" aria-hidden="true" focusable="false">
			<use xlink:href="@Assets/svg/symbol-defs.svg#question-circle"/>
		</svg>
		<div class="notice-info">
			<p class="text-left">
				<svg width="1em" class="svg-middle" viewBox="0 0 512 512" aria-hidden="true" focusable="false">
					<use xlink:href="@Assets/svg/symbol-defs.svg#question-circle"/>
				</svg>
				{{ $t('vm.root.parameters.google-review.informations') }}
				 <br>
				{{ $t('vm.root.parameters.google-review.informations2') }}
			</p>
		</div>
	</collapsible-help>

	<div class="marg-v">
		<input-action-frame id="google-link-id"  v-model="configuration.google_review.review_link_id"
		                    :label="$t('vm.root.parameters.google-review.link-id.label')"
		                    :placeholder="$t('vm.root.parameters.google-review.link-id.placeholder')"
		                    :title="$t('vm.root.parameters.google-review.link-id.title')"
		                    :button-label="$t('vm.root.parameters.google-review.button-label')"
		                    :button-title="$t('vm.root.parameters.google-review.button-title')"
		                    :disabled="!configuration.google_review.review_link_id"
		                    @action="previewGoogleReviewLink"
		                    :icon="'eye'" />

	</div>
	<div class="marg-v">
		<textarea-frame id="google-review-text" v-model="configuration.google_review.review_text"
						:label="$t('vm.root.parameters.google-review.text-review.label', {length: reminderTextLength})"
						:error-test="googleReviewError" :error-msg="googleReviewErrorMessage"
						:placeholder="$t('vm.root.parameters.google-review.text-review.placeholder')"
						:title="$t('vm.root.parameters.google-review.text-review.title')"
						:disabled="!configuration.google_review.review_link_id" />
	</div>

	<div class="marg-v">
		<switch-frame id="google-invoice" :title="$t('vm.root.parameters.google-review.invoice.title')"
					  :disabled="!configuration.google_review.review_link_id"
					  v-model="configuration.google_review.use_in_invoice_mail">
			{{ $t('vm.root.parameters.google-review.invoice.label') }}
		</switch-frame>
	</div>

	<div class="marg-v">
		<switch-frame id="google-follow-up" :title="$t('vm.root.parameters.google-review.follow_up.title')"
					  :disabled="!configuration.google_review.review_link_id"
					  v-model="configuration.google_review.use_in_follow_up_mail">
			{{ $t('vm.root.parameters.google-review.follow_up.label') }}
		</switch-frame>
	</div>

	<div class="marg-v">
		<switch-frame id="google-relaunch" :title="$t('vm.root.parameters.google-review.relaunch.title')"
					  :disabled="!configuration.google_review.review_link_id"
					  v-model="configuration.google_review.use_in_relaunch_mail">
			{{ $t('vm.root.parameters.google-review.relaunch.label') }}
		</switch-frame>
	</div>

</div>
